import React, { useEffect } from 'react'

function LoginMeta() {

    useEffect(() => {
        let urlParams = new URLSearchParams(window.location.search);
        console.log("URL Params:", urlParams);
        // if (Object.keys(urlParams).length === 0) {
        //     urlParams = new URLSearchParams(window.location.hash.substring(1));
        //     console.log("URL Params from hash:", urlParams);
        // }

        if (window.opener) {
            const params = {};
            for (const [key, value] of urlParams.entries()) {
                params[key] = value;
            }
            window.opener.postMessage({ ...params, type: "meta_code" }, "*");
            window.close();
        }
    }, []);

    return (
        <div className="bg-white max-h-[550px] overflow-auto">
            <div className="pt-2 pr-4 pl-4">
                <div>
                    <div className="text-[14px] min-h-[200px] mt-20 text-center">
                        <label className="font-semibold text-[16px]">
                            Thanks for connecting Instagram with iOmnihub. You can now start Instagram chats directly from the iOmnihub portal.
                        </label>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoginMeta